import React, { useCallback } from 'react';
import styles from './page-three.module.scss';
import { cookieList, Section, TableRow } from '../constants';
import { CookieUtils } from '../utils';

const imgSrc = require('./assets/popup_close_button_hover@2x.png');

type RowProps = {
  data: TableRow;
};
export const Row = ({ data }: RowProps) => {
  return (
    <tr className={styles['table-row']}>
      <td className={styles['table-cell-1']}>{data.cookieName}</td>
      <td className={styles['table-cell-2']}>{data.type}</td>
      <td className={styles['table-cell-2']}>{data.description}</td>
    </tr>
  );
};

type SectionProps = {
  section: Section;
};
export const CookieSection = ({ section }: SectionProps) => {
  const tableRows = section.table.map(row => (
    <Row key={row.cookieName} data={row} />
  ));
  return (
    <section aria-labelledby={`${section.section}-section`}>
      <h2
        id={`${section.section}-section`}
        className={styles.header}
      >{`${section.sectionTitle}`}</h2>
      <table className={styles['section-table']}>
        <tr className={styles['table-header']}>
          <th className={styles['table-cell-1']}>
            {polyglot.t('cookie_policy.page_three.cookie_name')}
          </th>
          <th className={styles['table-cell-2']}>
            {polyglot.t('cookie_policy.page_three.type')}
          </th>
          <th className={styles['table-cell-2']}>
            {polyglot.t('cookie_policy.page_three.description')}
          </th>
        </tr>
        {tableRows}
      </table>
    </section>
  );
};

type Props = {
  changePage: () => void;
  cookieUtils: CookieUtils;
};

export const PageThree = ({ cookieUtils, changePage }: Props) => {
  const closeButtonRef = useCallback(closeButton => {
    if (closeButton) {
      closeButton.focus();
    }
  }, []);

  const _cookieList = cookieList();
  const cookieDisplay = _cookieList[cookieUtils.platform].map(cookieSection => (
    <CookieSection key={cookieSection.section} section={cookieSection} />
  ));
  return (
    <div className={styles.wrapper}>
      {cookieDisplay}
      <div>
        <button
          ref={closeButtonRef}
          aria-label={polyglot.t('cookie_policy.page_three.return')}
          onClick={changePage}
          className={styles['close-button']}
        >
          <img src={imgSrc} alt='' />
        </button>
      </div>
    </div>
  );
};

PageThree.displayName = 'PageThree';
